import { connect } from "react-redux";
import { useEffect, useState } from "react";
import { Input, MessageBarBody, MessageBarTitle, Textarea } from "@fluentui/react-components";
import { ErrorMessageComponent } from "../../Error/ErrorMessageComponent";
import { ContractToClone } from "../../../models/Entities/Contracts/ContractToClone";

// guide components
import { GuideDrawer, GuideDrawerForm } from "../../../theme/components/GuideDrawer";
import { GuideField } from "../../../theme/components/GuideField";
import { GuideMessageBar } from "../../../theme/components/GuideMessageBar";

//i18Next
import { useTranslation } from 'react-i18next';

// component functions
import * as ComponentFunctions from './ContractCloneForm.Functions';

interface FormValidation {
    success: boolean;
    errors: string[];
}

export const ContractCloneFormComponent = (props: ComponentFunctions.Props) => {

    const [submittedForm, setSubmittedForm] = useState<boolean>(false);
    const [FormValidationStatus, setFormValidationStatus] = useState<
        FormValidation | undefined
    >();

    // translation
    const [t] = useTranslation();

    // clone contract entity properties
    /*
        contractToCloneId: number;
        contractName: string;
        comments: string;
        isChild: boolean;
    */

    const [contractName, setContractName] = useState<string>();
    const [comments, setComments] = useState<string>();
    const [isChild, setIsChild] = useState<boolean>(false);

    // events
    const HandleSaveForm = () => {
        setSubmittedForm(true);
        if (ValidateForm()) {
            let CurrentValues: ContractToClone;
            CurrentValues = {
                contractToCloneId: props.ContractId,
                contractName: contractName!,
                comments: comments!,
                isChild: isChild!
            }

            props.CloneContract(CurrentValues);
        }
    };

    const HandleCancelForm = () => {
        ResetForm();
        props.dismissPanel();
    };

    useEffect(() => {
        contractName === undefined && setContractName('Clone - ' + props.Contract?.contractNumber);
    }, [props.Contract]);

    useEffect(() => {
        if (submittedForm && props.isClonedSuccessfully) {
            ResetForm();
            props.dismissPanel();
        }
    }, [submittedForm, props.isClonedSuccessfully]);

    const ValidateForm = (): boolean => {
        let validationResult: boolean = true;

        let FormValidation: FormValidation = { success: true, errors: [] };
        setFormValidationStatus(FormValidation);

        // validate contract name
        if (!contractName) {
            validationResult = false;
            FormValidation.errors.push(t('ContractCloneForm.formValidation.informName'));
        }

        FormValidation.success = validationResult;
        setFormValidationStatus(FormValidation);
        return validationResult;
    };

    const ResetForm = () => {
        setSubmittedForm(false);
        setContractName(undefined);
        setComments(undefined);
        setIsChild(false);
    }

    return (
        <GuideDrawer
            open={props.isOpen}
            size="medium"
            eyebrow={props.Contract?.contractNumber}
            title={t('ContractCloneForm.panel.contractInformation')}
            onDismiss={props.dismissPanel}
            testId="contract-clone-drawer"
            secondaryAction={{ label: t('cycleForm.footer.cancelButton'), onClick: HandleCancelForm }}
            primaryAction={{ label: t('cycleForm.footer.saveButton'), onClick: HandleSaveForm, loading: props.isCloning }}
        >
            {submittedForm && !FormValidationStatus?.success && (
                <GuideMessageBar intent="error">
                    <MessageBarBody>
                        <MessageBarTitle>{t('ContractCloneForm.panel.reviewInformation')}</MessageBarTitle>
                        <ul>
                            {FormValidationStatus?.errors.map(
                                (Error: string, index: number) => (
                                    <li key={index}>{Error}</li>
                                )
                            )}
                        </ul>
                    </MessageBarBody>
                </GuideMessageBar>
            )}
            {props.failOnCloning &&
                props.error && (
                    <ErrorMessageComponent Error={props.error} />
                )}
            <GuideDrawerForm onSubmit={HandleSaveForm} testId="contract-clone-form">
                <GuideField
                    label={t('ContractCloneForm.props.contractName')}
                    required
                    error={submittedForm && !contractName ? t('ContractCloneForm.props.requiredField') : undefined}
                >
                    <Input
                        value={contractName ?? ''}
                        onChange={(_, data) => setContractName(data.value)}
                    />
                </GuideField>
                <GuideField label={t('ContractCloneForm.props.comments')}>
                    <Textarea
                        resize="vertical"
                        value={comments ?? ''}
                        onChange={(_, data) => setComments(data.value)}
                    />
                </GuideField>
            </GuideDrawerForm>
        </GuideDrawer>
    );
}

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(ContractCloneFormComponent as any);
